export default {
  //get all SUPERADMIN_STUDENTs
  GET_SUPERADMIN_STUDENTS_REQUEST: "GET_SUPERADMIN_STUDENTS_REQUEST",
  GET_SUPERADMIN_STUDENTS_SUCCESS: "GET_SUPERADMIN_STUDENTS_SUCCESS",
  GET_SUPERADMIN_STUDENTS_FAIL: "GET_SUPERADMIN_STUDENTS_FAIL",

  GET_SUPERADMIN_ACTIVE_STUDENTS_REQUEST:
    "GET_SUPERADMIN_ACTIVE_STUDENTS_REQUEST",
  GET_SUPERADMIN_ACTIVE_STUDENTS_SUCCESS:
    "GET_SUPERADMIN_ACTIVE_STUDENTS_SUCCESS",
  GET_SUPERADMIN_ACTIVE_STUDENTS_FAIL: "GET_SUPERADMIN_ACTIVE_STUDENTS_FAIL",
  //edit SUPERADMIN_STUDENTs
  REJECT_SUPERADMIN_STUDENT_REQUEST: "REJECT_SUPERADMIN_STUDENT_REQUEST",
  REJECT_SUPERADMIN_STUDENT_SUCCESS: "REJECT_SUPERADMIN_STUDENT_SUCCESS",
  REJECT_SUPERADMIN_STUDENT_FAIL: "REJECT_SUPERADMIN_STUDENT_FAIL",

  APPROVE_SUPERADMIN_STUDENT_REQUEST: "APPROVE_SUPERADMIN_STUDENT_REQUEST",
  APPROVE_SUPERADMIN_STUDENT_SUCCESS: "APPROVE_SUPERADMIN_STUDENT_SUCCESS",
  APPROVE_SUPERADMIN_STUDENT_FAIL: "APPROVE_SUPERADMIN_STUDENT_FAIL",

  SUPERADMIN_ADD_BULK_STUDENT_REQUEST: "SUPERADMIN_ADD_BULK_STUDENT_REQUEST",
  SUPERADMIN_ADD_BULK_STUDENT_SUCCESS: "SUPERADMIN_ADD_BULK_STUDENT_SUCCESS",
  SUPERADMIN_ADD_BULK_STUDENT_FAIL: "SUPERADMIN_ADD_BULK_STUDENT_FAIL",
  CREATE_SUPERADMIN_STUDENT_REQUEST: "CREATE_SUPERADMIN_STUDENT_REQUEST",
  CREATE_SUPERADMIN_STUDENT_SUCCESS: "CREATE_SUPERADMIN_STUDENT_SUCCESS",
  CREATE_SUPERADMIN_STUDENT_FAIL: "CREATE_SUPERADMIN_STUDENT_FAIL",
  EDIT_SUPERADMIN_STUDENT_REQUEST: "EDIT_SUPERADMIN_STUDENT_REQUEST",
  EDIT_SUPERADMIN_STUDENT_SUCCESS: "EDIT_SUPERADMIN_STUDENT_SUCCESS",
  EDIT_SUPERADMIN_STUDENT_FAIL: "EDIT_SUPERADMIN_STUDENT_FAIL",
  //loading
  SUPERADMIN_STUDENTS_LOADING: "SUPERADMIN_STUDENTS_LOADING",

  DELETE_SUPERADMIN_STUDENT_REQUEST: "DELETE_SUPERADMIN_STUDENT_REQUEST",
  DELETE_SUPERADMIN_STUDENT_SUCCESS: "DELETE_SUPERADMIN_STUDENT_SUCCESS",
  DELETE_SUPERADMIN_STUDENT_FAIL: "DELETE_SUPERADMIN_STUDENT_FAIL",

  RESET_STUDENT_PASSWORD_REQUEST: "RESET_STUDENT_PASSWORD_REQUEST",
  RESET_STUDENT_PASSWORD_SUCCESS: "RESET_STUDENT_PASSWORD_SUCCESS",
  RESET_STUDENT_PASSWORD_FAIL: "RESET_STUDENT_PASSWORD_FAIL",
};
